import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../application/config/config';
import { useMemo } from 'react';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';

function List() {
    const profileFilter = chooseProfileFilter();
    const pathFrontEnd = '/governanceroom/departments/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpoint: `${config.endpoints.backend}governanceroom/departments/getall`,
        endpointDelete: `${config.endpoints.backend}governanceroom/departments/delete`,
    }

    const list = useMemo(() => ({
        labelTitle: 'Departamentos',
        labelTitleButtonAdd: 'Novo departamento',
        fieldsShowOnDelete: ['title_deparment'],
        filter:{
            ...profileFilter
        },
        showPrintButtons: false,
        canDelete: true,
        canEdit: true,
        columns: [
            {
                name: 'title_department',
                label: 'Departamento',
                width: '30%'
            },
            {
                name: 'secretariat_name',
                label: 'Secretaria',
                width: '30%'
            },
            {
                name: 'geo_city_name',
                label: 'Município',
                width: '30%'
            }
        ],
        ...paths
    }), []);

    const content = useMemo(() => (
        <CustomList list={{ ...list, ...paths }} />
    ), [list]);

    const customListContainer = useMemo(() => (
    <CustomListContainer
        pathAdd={paths.pathAdd}
        labelTitle={list.labelTitle}
        labelTitleButtonAdd={list.labelTitleButtonAdd}
        content={content}
    />
    ), [content, list.labelTitle, list.labelTitleButtonAdd, paths.pathAdd]);
    
    return (
        <div>
            {customListContainer}
        </div>
    );
}
export default List;